var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrackProgressIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#track-progress-icon_svg__a)",
  d: "M23.354 3.958c-7.537 0-13.647 6.11-13.647 13.647s6.11 13.647 13.647 13.647C30.89 31.252 37 25.142 37 17.605S30.89 3.958 23.354 3.958"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#track-progress-icon_svg__b)",
  shapeRendering: "crispEdges"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M17.352 2.253C8.873 2.253 2 9.127 2 17.605s6.873 15.352 15.352 15.352 15.352-6.873 15.352-15.352S25.83 2.253 17.352 2.253"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#track-progress-icon_svg__c)",
  d: "M2.5 17.605c0-8.202 6.65-14.852 14.852-14.852s14.852 6.65 14.852 14.852-6.65 14.852-14.852 14.852S2.5 25.807 2.5 17.605Z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#track-progress-icon_svg__d)",
  d: "M28.617 17.829A11.265 11.265 0 1 1 17.352 6.563"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#track-progress-icon_svg__e)",
  strokeDasharray: "3 3",
  d: "M17.352 6.563A11.265 11.265 0 0 1 28.617 17.83"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#track-progress-icon_svg__f)",
  shapeRendering: "crispEdges"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#track-progress-icon_svg__g)",
  fillRule: "evenodd",
  d: "M22.795 14.677a1.02 1.02 0 0 1 0 1.503l-5.273 4.96c-.212.2-.5.311-.8.311s-.587-.112-.798-.31l-3.014-2.835a1.02 1.02 0 0 1 0-1.503 1.18 1.18 0 0 1 1.598 0l2.215 2.082 4.474-4.208a1.18 1.18 0 0 1 1.598 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#track-progress-icon_svg__h)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.171,
  d: "M22.737 14.74a.933.933 0 0 1 0 1.378l-5.274 4.96a1.08 1.08 0 0 1-.74.288c-.279 0-.545-.104-.74-.288l-3.014-2.834a.933.933 0 0 1 0-1.379 1.096 1.096 0 0 1 1.48 0l2.215 2.083a.086.086 0 0 0 .117 0l4.475-4.208a1.096 1.096 0 0 1 1.48 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "track-progress-icon_svg__a",
  x1: 37,
  x2: 9.707,
  y1: 17.605,
  y2: 17.605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DBA3EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7038E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "track-progress-icon_svg__c",
  x1: 2,
  x2: 32.704,
  y1: 17.605,
  y2: 17.602,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "track-progress-icon_svg__d",
  x1: 7.677,
  x2: 31.253,
  y1: 8.335,
  y2: 33.374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "track-progress-icon_svg__e",
  x1: 27.731,
  x2: 15.212,
  y1: 7.359,
  y2: 19.147,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "track-progress-icon_svg__g",
  x1: 14.227,
  x2: 30.678,
  y1: 17.067,
  y2: 19.135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "track-progress-icon_svg__h",
  x1: 12.879,
  x2: 19.534,
  y1: 15.377,
  y2: 17.735,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "track-progress-icon_svg__b",
  width: 56.704,
  height: 56.704,
  x: -11,
  y: -10.747,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 6.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_11867_2841"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_backgroundBlur_11867_2841",
  result: "effect2_dropShadow_11867_2841"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_11867_2841",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "track-progress-icon_svg__f",
  width: 11.246,
  height: 7.785,
  x: 12.229,
  y: 14.366,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.35
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.175
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11867_2841"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11867_2841",
  result: "shape"
})))));
export default SvgTrackProgressIcon;